import {
  BlockOutlined,
  CloseCircleOutlined,
  DeleteFilled,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  KeyOutlined,
  LockOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { Modal, Button, Row, Col, notification, Form, message, Input } from 'antd';
import Tooltip from 'antd/es/tooltip';
import Skeleton from 'antd/lib/skeleton';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormularioUsuario from '../app/features/FormularioUsuario';
import useLojaUsuario from '../core/hooks/useUserLoja';
import { UserService, Usuarios } from '../sdk';
import ModalBloqueiosUsuario from './ModalBloqueiosUsuario';

const ModalUsuario = (props: { idUsuario: string; quandoFinalizar: () => any; cnpj?: string; }) => {
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState('Form de cadastro de usuários');
  const [showCreationModal, setShowCreationModal] = useState(false);
  const openCreationModal = useCallback(() => setShowCreationModal(true), []);
  const closeCreationModal = useCallback(() => setShowCreationModal(false), []);

  const [bloqueiosModal, setBloqueiosModal] = useState(false);
  const openBloqueiosModal = useCallback(() => setBloqueiosModal(true), []);
  const closeBloqueiosModal = useCallback(() => setBloqueiosModal(false), []);
  const [senhaModalOpen, setSenhaModalOpen] = useState(false); // ← Novo estado

  const [form] = Form.useForm(); // ← Form do Ant Design


  const parametroUrl = useParams<{ id: string }>();

  //fazer a busca
  const { usuarioLoja, fetchUsuarioLoja } = useLojaUsuario();

  useEffect(() => {
    // chamar consulta do usuario novamente
    fetchUsuarioLoja(props.idUsuario);
  }, [fetchUsuarioLoja, props.idUsuario]);

  // ==================== ALTERAR SENHA ====================
  const handleAlterarSenha = async () => {
    try {
      const values = await form.validateFields();

      if (values.newPassword !== values.confirmPassword) {
        message.error('As senhas não coincidem!');
        return;
      }

      if (usuarioLoja?.id) {
        await UserService.alterarSenha(values.newPassword, usuarioLoja.id);
        message.success('Senha alterada com sucesso!');
        setSenhaModalOpen(false);
        form.resetFields();
        props.quandoFinalizar();
      }
    } catch (error) {
      message.error('Erro ao alterar a senha.');
    }
  };

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <Tooltip title={'Bloqueios'} placement={'left'}>
        <Button size='small' icon={<CloseCircleOutlined />} onClick={openBloqueiosModal} />
      </Tooltip>
      <Tooltip title={'Editar Usuário'} placement={'left'}>
        <Button size='small' icon={<EditOutlined />} onClick={openCreationModal} />
      </Tooltip>
      <Tooltip title={'Excluir Usuário'} placement={'right'}>
        <Button
          size='small'
          icon={<DeleteFilled />}
          type={'default'}
          htmlType={'button'}
          onClick={async () => {
            const confirmed = window.confirm(
              'Tem certeza de que deseja excluir o usuário?'
            );

            if (confirmed) {
              try {
                if (usuarioLoja?.id) {
                  await UserService.excluirUsuario(usuarioLoja?.id);
                  alert('Exclusão concluída com sucesso!');
                  props.quandoFinalizar();
                } else {
                  alert('Erro ao excluir o usuário.');
                }
              } catch (error) {
                alert('Erro ao excluir o usuário.');
              }
            }
          }}
          style={{ color: 'red' }}
        />
      </Tooltip>

      {/* ==================== BOTÃO ALTERAR SENHA (NOVO) ==================== */}
      <Tooltip title={'Alterar Senha'} placement={'right'}>
        <Button
          size='small'
          icon={<LockOutlined />}           // Ícone mais bonito
          type={'default'}
          onClick={() => setSenhaModalOpen(true)}
          style={{ color: 'black' }}
        />
      </Tooltip>

      {/* ==================== MODAL DE ALTERAR SENHA ==================== */}
      <Modal
        title="Alterar Senha"
        visible={senhaModalOpen}                    // ← Alterado de 'open' para 'visible'
        onOk={handleAlterarSenha}
        onCancel={() => {
          setSenhaModalOpen(false);
          form.resetFields();
        }}
        okText="Alterar Senha"
        cancelText="Cancelar"
        destroyOnClose
        confirmLoading={confirmLoading}            // opcional, mas recomendado
      >
        <Form
          form={form}
          layout="vertical"
          name="formAlterarSenha"
        >
          <Form.Item
            label="Nova Senha"
            name="newPassword"
            rules={[
              { required: true, message: 'Digite a nova senha' },
              { min: 1, message: 'A senha deve ter no mínimo 1 caracter' },
            ]}
          >
            <Input.Password
              prefix={<KeyOutlined />}
              placeholder="Digite a nova senha"
              autoComplete="new-password"
            />
          </Form.Item>

          <Form.Item
            label="Confirmar Nova Senha"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Confirme a nova senha' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('As senhas não coincidem!'));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<KeyOutlined />}
              placeholder="Confirme a senha"
              autoComplete="new-password"
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title='Usuários'
        footer={null}
        visible={showCreationModal}
        onCancel={closeCreationModal}
        destroyOnClose
      >
        {usuarioLoja ? (
          <FormularioUsuario
            onSuccess={() => {
              closeCreationModal();
              props.quandoFinalizar();
              notification.success({
                message: 'Usuário Editado com sucesso',
                top: 80,
              });
              fetchUsuarioLoja(props.idUsuario);
            }}
            usuarioLoja={usuarioLoja}
            modal={true}
            cnpj={props.cnpj}
          ></FormularioUsuario>
        ) : (
          <Skeleton></Skeleton>
        )}
      </Modal>


      <Modal
        title="Usuários"
        footer={null}
        visible={bloqueiosModal}
        onCancel={closeBloqueiosModal}
        destroyOnClose
        width={1000}
      >
        {usuarioLoja ? (
          <ModalBloqueiosUsuario
            onSuccess={() => {
              closeBloqueiosModal();
              //props.quandoFinalizar();
              notification.success({
                message: 'Bloqueios editados com sucesso',
                top: 80,
              });
              fetchUsuarioLoja(props.idUsuario);
            }}
            usuarioID={usuarioLoja.id}
          // modal={true}
          //cnpj={props.cnpj}
          ></ModalBloqueiosUsuario>
        ) : (
          <Skeleton></Skeleton>
        )}
      </Modal>
    </div>
  );
};

export default ModalUsuario;
